import { useRequesterStore } from '../stores/requester'
import type { SaveBudgetPayload } from '../types/budget'

let requesterX: any

export async function createBudget(body: SaveBudgetPayload) {
  requesterX = requesterX ? requesterX : useRequesterStore()
  return requesterX.Post({
    route: `/budget/create`,
    withAuth: true,
    body,
  })
}

export async function getBudgetToday() {
  requesterX = requesterX ? requesterX : useRequesterStore()
  return requesterX.Get({
    route: `/budget/today`,
    withAuth: true,
  })
}

export async function getAllBudgets() {
  requesterX = requesterX ? requesterX : useRequesterStore()
  return requesterX.Get({
    route: `/budget`,
    withAuth: true,
  })
}

export async function setBudgetEnabled(id: number, enabled: boolean) {
  requesterX = requesterX ? requesterX : useRequesterStore()
  return requesterX.Put({
    route: `/budget/status`,
    withAuth: true,
    body: { id, enabled },
  })
}

export async function deleteBudget(id: number) {
  requesterX = requesterX ? requesterX : useRequesterStore()
  return requesterX.Delete({
    route: `/budget/delete/${id}`,
    withAuth: true,
  })
}
